class Package {
  constructor(json) {
    this.json = json;
    this.lengthInches = json.length_inches;
    this.widthInches = json.width_inches;
    this.heightInches = json.height_inches;
    this.weightPounds = json.weight_pounds;
  }
}

module.exports = Package;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/package.js